(function() {
  // Single global click handler
  window.roomvoButtonClick = function(sku) {
    console.log('Button clicked with SKU:', sku);
    
    if (!window.roomvo) {
      console.error('Roomvo not available');
      return false;
    }

    // Add a small delay before starting visualizer
    setTimeout(() => {
      try {
        console.log('Starting visualizer with SKU:', sku);
        window.roomvo.startStandaloneVisualizer('16', sku);
      } catch(e) {
        console.error('Error:', e);
      }
    }, 100);

    return true;
  };

  // Simple initialization check
  function initRoomvo() {
    if (typeof window.roomvo === 'undefined') {
      setTimeout(initRoomvo, 1000);
    }
  }

  // Start checking when page loads
  document.addEventListener('DOMContentLoaded', initRoomvo);
})();